import { useMemo } from 'react';

import {
  type DienstregelpuntGroupedOption,
  getDienstregelpuntenGroupedOptions,
} from '@/views/ddp/utils/voorraadbeheer';

import GroupedCreatableSelectField from './GroupedCreatableSelectField';

type DienstregelpuntOption = { label: string; value: string };

const getDienstregelpuntExactMatchLabel = (optionLabel: string) => optionLabel.replace(/ toevoegen$/i, '');

type DienstregelpuntSelectFieldProps = {
  control: any;
  name: string;
  label?: string;
  testId?: string;
  placeholder?: string;
  defaultValue?: DienstregelpuntOption[];
  alleDrglptnamen?: string[];
};

export default function DienstregelpuntSelectField({
  control,
  name,
  label = 'Dienstregelpunten',
  testId = 'dienstregelpunten',
  placeholder = 'Voeg dienstregelpunt(en) toe',
  defaultValue = [],
  alleDrglptnamen = [],
}: DienstregelpuntSelectFieldProps) {
  const groupedOptions = useMemo(() => getDienstregelpuntenGroupedOptions(), []);

  const flatDrglptOptions = useMemo(
    () => alleDrglptnamen.map((name) => ({ label: name, value: [name] })),
    [alleDrglptnamen],
  );

  const combinedOptions: DienstregelpuntGroupedOption[] = useMemo(
    () => [...groupedOptions, { label: 'Dienstregelpunten', options: flatDrglptOptions }],
    [groupedOptions, flatDrglptOptions],
  );

  return (
    <GroupedCreatableSelectField
      control={control}
      name={name}
      label={label}
      testId={testId}
      placeholder={placeholder}
      defaultValue={defaultValue}
      options={combinedOptions}
      filterMatchFrom='start'
      formatCreateLabel={(input) => `Dienstregelpunt: ${input}`}
      getExactMatchLabel={getDienstregelpuntExactMatchLabel}
    />
  );
}
